import type { AccountConsentRequest, BankAccount } from "@/model/account";

export const getAccountConsent = async (
  userId: string,
): Promise<{ consentExpired: boolean; accountExists: boolean }> => {
  const url = `/api/account/${userId}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getAccountConsent exception: ${error}`);
    throw error;
  }
};

export const getAccounts = async (): Promise<BankAccount[]> => {
  const url = `/api/accounts`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getAccounts exception: ${error}`);
    throw error;
  }
};

export const getCorporateAccounts = async (
  corporateUserId: string,
): Promise<BankAccount[]> => {
  const url = `/api/corporate-accounts/${corporateUserId}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getCorporateAccounts exception: ${error}`);
    throw error;
  }
};

export const validateBBAN = async (
  bban: string,
  externalId?: string,
): Promise<{
  bban: string;
  errorMessage: string;
  iban: string;
  isValid: boolean;
}> => {
  const url = `/api/account/validate-bban`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ bban, externalId }),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`validateBBAN: ${error}`);
    throw error;
  }
};

export const addBankAccount = async (
  bban: string,
  corporateId: string,
): Promise<BankAccount> => {
  const url = `/api/accounts/add`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ bban, corporateId }),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`AddBankAccount: ${error}`);
    throw error;
  }
};

export const requestBankAccountConsent = async (
  accountConsentRequest: AccountConsentRequest,
): Promise<{ id: string }> => {
  const url = `/api/account/request`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(accountConsentRequest),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`export const requestBankAccountConsent = async (
: ${error}`);
    throw error;
  }
};

export const getAccountRequest = async (
  requestId: string,
): Promise<{ status: string; scaRedirectUrl: string }> => {
  const url = `/api/account/request/${requestId}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getAccountRequest exception: ${error}`);
    throw error;
  }
};
